import { TypeDefinition } from "../models/generic";

export class NavigationTypes {
    public static Placeholder: TypeDefinition = { id: 0, name: "Placeholder" };
    public static Redirect: TypeDefinition = { id: 1, name: "Redirect" };
    public static Separator: TypeDefinition = { id: 2, name: "Separator" };
    public static Page: TypeDefinition = { id: 3, name: "Page" };
    public static Event: TypeDefinition = { id: 4, name: "Event" };

    public static Values: TypeDefinition[] = [
        NavigationTypes.Placeholder,
        NavigationTypes.Redirect,
        NavigationTypes.Separator,
        NavigationTypes.Page,
        NavigationTypes.Event,
    ];

    public static isContentType = (typeId: number) => {
        return typeId !== NavigationTypes.Redirect.id
            && typeId !== NavigationTypes.Separator.id;
    }
}



// WEBPACK FOOTER //
// ./src/domain/NavigationTypes.ts